module.exports = "<dl class=\"form-element\">\n    <dt>\n        <label>Kategoria</label>\n    </dt>\n    <dd>\n        <select\n            ng-class=\"IssueFormCategoryCtrl.isFullWidth ? 'full-width' : ''\"\n            name=\"category\"\n            ng-model=\"IssueFormCategoryCtrl.category\"\n            ng-options=\"item as item.name for item in IssueFormCategoryCtrl.dataFromBackend track by item.id\"\n        >\n            <option value=\"\">-- Wybierz kategorię --</option>\n        </select>\n    </dd>\n</dl>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/issues/issue_forms/fragments/category/issue_form_category.html
// module id = 643
// module chunks = 0